import useSWR from 'swr'
import { dayInMs } from '../utils/constants'
import { useEffect } from 'react'

export default function useTickers(isCallable = true, AutoLoginStatus = true) {
    const { data, error } = useSWR(isCallable && !AutoLoginStatus && `/api/tickers`, { dedupingInterval: dayInMs })

    const checkPrivateCompany = (ticker) => {
        const tickerInfo = data?.find((tickerObj => tickerObj.value === ticker))
        return tickerInfo ? tickerInfo.category === 'Private' : null
    }

    const getTickerName = (companyTicker) => data?.find(ticker => companyTicker === ticker.value)?.name

    return {
        tickers: data || [],
        loading: !data && !error,
        checkPrivateCompany,
        getTickerName
    }
}